import { useMemo } from 'react';

export const useOptionMapper = props => {
  const { valueKey, labelKey, labelFunction, readOnlyList, relationKey } = props;

  const optionMapper = useMemo(() => {
    const mapValueToOption = value => {
      const key = value[valueKey];
      const label = typeof labelFunction === 'function' ? labelFunction(value) : value[labelKey];

      return {
        value: key,
        label: label,
        data: value,
        isDisabled: readOnlyList && readOnlyList.includes(key),
      };
    };

    const mapSelectedValuesToOptions = selectedValues => {
      // trying to handle both direct values and relation objects 🤞 ( I am not sure if I totally understand what's going on here)
      const { singleSelect } = props;

      if (singleSelect) {
        if (!selectedValues) return null;
        const value = relationKey ? selectedValues[relationKey] : selectedValues;
        return value ? { value, label: `Item ${value}` } : null;
      }

      if (!Array.isArray(selectedValues)) return [];

      return selectedValues.map(item => {
        if (typeof item === 'object' && relationKey) {
          return mapValueToOption({
            [valueKey]: item[relationKey],
            [labelKey]: `Item ${item[relationKey]}`,
          });
        }
        return mapValueToOption({
          [valueKey]: item,
          [labelKey]: `Item ${item}`,
        });
      });
    };

    return {
      mapValueToOption,
      mapSelectedValuesToOptions,
    };
  }, [valueKey, labelKey, labelFunction, readOnlyList, relationKey, props]);

  return optionMapper;
};
